import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Route from './Routes';
import { ToastContainer } from 'react-toastify';
import { profiledata } from '../src/slices/thunks';
import { getCurrentUser } from 'aws-amplify/auth';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import './assets/scss/themes.scss';
import './App.css';

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const authUser = localStorage.getItem('authUser');
  const [cognito_id, setCognito_id] = useState(null);
  const navigate = useNavigate();
  const [showCard, setShowCard] = useState(false);
  const [currentPlanType, setCurrentPlanType] = useState('Monthly');
  const [animateDirection, setAnimateDirection] = useState('');
  const [bannerMessage, setBannerMessage] = useState('Your current plan is expired');

  const styles = {
    heading: {
      color: 'red',
      fontSize: '20px',
      fontWeight: 'bold',
      marginBottom: '15px',
    },
    strikeThrough: {
      textDecoration: 'line-through',
      color: 'grey',
    },
    price: {
      fontSize: '24px',
      color: 'black',
      fontWeight: 'bold',
    },

    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    card: {
      padding: 20,
      backgroundColor: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      width: '50%',
    },

    planContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '20px',
      position: 'relative',
      transition: 'transform 0.5s ease-in-out',
    },

    slideLeft: {
      transform: 'translateX(100%)',
    },
    slideRight: {
      transform: 'translateX(-100%)',
    },

    planCard: {
      backgroundColor: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      padding: 20,
      textAlign: 'center',
      width: '50%',
    },
    subHeading: {
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    arrowButton: {
      margin: '10px',
      padding: '10px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      fontSize: '18px',
    },

    upgradeButton: {
      marginTop: '20px',
      padding: '10px 20px',
      backgroundColor: '#155724',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    flexRow: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '20px',
    },
    closeDiv: {
      display: "flex",
      justifyContent: 'flex-end',
      top: '0 px',
      right: '10px',
    },
    closeButton: {
      fontSize: '30px',
      color: 'black',
      border: 'none',
      cursor: 'pointer',
    }

  }
  useEffect(() => {
    const getuser = async () => {
      if (authUser) {
        const parsedAuthUser = await getCurrentUser();
        const cognitoId = parsedAuthUser.username;
        setCognito_id(cognitoId);
        dispatch(profiledata(cognitoId));
      }
    };
    getuser();
  }, [authUser, cognito_id]);

  const profileData = useSelector((state) => state.Profile.profileData);

  useEffect(() => {
    if (profileData) {
      const {
        next_charge_date,
        status,
        current_plan,
        storage_quota,
        storage_used,
        bandwidth_quota,
        bandwidth_used
      } = profileData.result;

      const nextChargeDate = new Date(next_charge_date);
      const currentDate = new Date();
      // const status = profileData?.result?.status;
      // const currentPlan = profileData?.result?.current_plan;
      // if (!(location.pathname === '/dam' && currentPlan === 'Basic')) {
      //   if (currentDate > nextChargeDate || status === 'INACTIVE') {
      //     setShowCard(true);
      //   }
      const remainingStorage = storage_quota - storage_used;
      const remainingBandwidth = bandwidth_quota - bandwidth_used;
      const fiveGBInBytes = 5 * 1024 * 1024 * 1024;

      if ((currentDate > nextChargeDate && current_plan !== 'Basic')|| status === 'INACTIVE') {
        setBannerMessage('Your current plan is expired. Please upgrade to continue.');
        setShowCard(true);
      } else if (remainingStorage < fiveGBInBytes || remainingBandwidth < fiveGBInBytes) {
        setBannerMessage('Your storage or bandwidth is running low. Please upgrade your plan.');
        setShowCard(true);
      }
    }
  // }, [profileData]);
  }, [profileData, location.pathname]);

  const handleUpgradeClick = () => {
    navigate('/billing/plans');
    setShowCard(false);
  };

  const togglePlan = (direction) => {
    setAnimateDirection(direction);
    setTimeout(() => {
      setCurrentPlanType((prevType) =>
        prevType === 'Monthly' ? 'Yearly' : 'Monthly'
      );
      setAnimateDirection('');
    }, 500);
  };

  const renderPlans = () => {
    return (
      <div style={{
        ...styles.planContainer,
        ...(animateDirection === 'slide-left' && styles.slideLeft),
        ...(animateDirection === 'slide-right' && styles.slideRight),
      }}>
        {currentPlanType === 'Monthly' ? (
          <>
            <div style={styles.planCard}>
              <p style={styles.subHeading}>Standard Plan - Monthly</p>
              <p>
                <span style={styles.strikeThrough}>$70.00</span>{' '}
                <span style={styles.price}>$50.00</span> per month
              </p>
              <ul>
                <li>1 users</li>
                <li>Custom Transcoding</li>
                <li>60 min Max video length</li>
                <li>500 GB Streaming DTO</li>
                <li>500 MB Max video upload</li>
              </ul>
            </div>
            <div style={styles.planCard}>
              <p style={styles.subHeading}>Premium Plan - Monthly</p>
              <p>
                <span style={styles.strikeThrough}>$700.00</span>{' '}
                <span style={styles.price}>$500.00</span> per month
              </p>
              <ul>
                <li>1 users</li>
                <li>Custom Transcoding</li>
                <li>180 min Max video length</li>
                <li>1 TB Streaming DTO</li>
                <li>2 GB Max video upload</li>
              </ul>
            </div>
          </>
        ) : (
          <>
            <div style={styles.planCard}>
              <p style={styles.subHeading}>Standard Plan - Yearly</p>
              <p>
                <span style={styles.strikeThrough}>$600.00</span>{' '}
                <span style={styles.price}>$480.00</span> per year
              </p>
              <ul>
                <li>1 users</li>
                <li>Custom Transcoding</li>
                <li>60 min Max video length</li>
                <li>500 GB Streaming DTO</li>
                <li>500 MB Max video upload</li>
              </ul>
            </div>
            <div style={styles.planCard}>
              <p style={styles.subHeading}>Premium Plan - Yearly</p>
              <p>
                <span style={styles.strikeThrough}>$6000.00</span>{' '}
                <span style={styles.price}>$4800.00</span> per year
              </p>
              <ul>
                <li>1 users</li>
                <li>Custom Transcoding</li>
                <li>180 min Max video length</li>
                <li>1 TB Streaming DTO</li>
                <li>2 GB Max video upload</li>
              </ul>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderHeading = () => {
    // if (profileData?.result?.current_plan === 'Basic') {
    //   return (<>
    //     <div className=''>
    //       <p style={styles.heading}>To explore more, upgrade your plan to ...</p>

    //     </div>
    //   </>
    //   );
    // } else {
      // return <p style={styles.heading}>Your current plan is expired</p>;
      return <p style={styles.heading}>{bannerMessage}</p>;
    // }
  };

  const closeCard = () => {
    setShowCard(false);
  };

  return (
    <React.Fragment>
      {/* {authUser && showCard && (
        <div style={styles.overlay}>
          <div style={styles.card}>
            <div style={styles.closeDiv}>
              <button style={styles.closeButton} onClick={closeCard}>
                ×
              </button>
            </div>
            {renderHeading()}
            {renderPlans()}
            <div style={styles.navigationArrows}>
              <button
                style={styles.arrowButton}
                onClick={() => togglePlan('slide-right')}
              >
                <FaArrowRight />
              </button>
            </div>
            <button style={styles.upgradeButton} onClick={handleUpgradeClick}>
              Upgrade Plan
            </button>
          </div>
        </div>
      )} */}

      <Route />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
}

export default App;
